import React, { Component } from 'react';
import { MessageBox } from '@eg/elements/MessageBox';
import { Button } from "@eg/elements/Button";

import "./Outcomes.scss";

class CheckoutSuccess extends Component {
  render() {
    return (
      <div className="esc_container outerContainer">
        <div className="esc_container esc_container--l"id="main-outcomes-container">
          <div>
            <MessageBox>
              <h1>Vielen Dank, dass Sie sich für den Internetschutzbrief entschieden haben.</h1>
              <p>Sie erhalten per E-Mail einen Link zum Download der Police</p>
              <p>Sofern Sie keine E-Mail erhalten haben, wenden Sie sich bitte an <a className="mail-link" href="mailto:internetschutzbrief@ergo.de">internetschutzbrief@ergo.de</a></p>
            </MessageBox>
          </div>
          <section className="esc_box-shadow--small esc_border-radius--small" id="wrapper">
            <div className="ProductPicture">
              <img id="imageComputerSafety" src={process.env.PUBLIC_URL + "/statics/images/Computersicherheit.jpg"} alt=""/>
            </div>
            <div className="ProductContent">
              <h3>Sicherheits-Paket für Ihr Hab und Gut</h3>
              <p>Ob Brand, Wasserschaden oder Einbruchdiebstahl - schützen Sie sich vor den finanziellen Folgen mit einer günstigen Hausratversicherung.</p>
              <Button style={{ float: "right" }}><a id="link-hausrat" target="_blank" rel="noopener noreferrer" href="https://www.ergo.de/de/Produkte/Hausrat-und-Gebaeudeversicherung" className="esc_text-link">Mehr erfahren</a></Button>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default CheckoutSuccess;
